import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TemplateWorkflowConfig } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TemplateService {
  constructor(private http: HttpClient) {}

  getByEntity(entity: string, recordEntity?: string, recordEntityId?: string): Observable<TemplateWorkflowConfig[]> {
    let url = `${environment.kpHost}/adv2/workflowconfig/${entity}`;
    if (recordEntity) {
      url += `?recordEntity=${recordEntity}`;
    }
    if (recordEntityId) {
      url += `&recordEntityId=${recordEntityId}`;
    }
    return this.http
      .get<TemplateWorkflowConfig[]>(url)
      .pipe(map((documentWorkflowConfigList) => documentWorkflowConfigList.map((dwc) => TemplateService.transform(dwc))));
  }

  private static transform(dwc: any): TemplateWorkflowConfig {
    return {
      actionConfigs: dwc.actionConfigs,
      clientId: dwc.clientId,
      clientNamespace: dwc.clientNamespace.toLowerCase(),
      createdBy: dwc.createdBy,
      dateCreated: dwc.dateCreated,
      dateModified: dwc.dateModified,
      entity: dwc.entity?.toLowerCase(),
      id: dwc.id,
      isPublic: dwc.isPublic,
      modifiedBy: dwc.modifiedBy,
      name: dwc.name,
      namespaces: dwc.namespaces,
      sections: dwc.sections,
      workflow: dwc.workflow,
      useFileAttachmentAsTemplate: dwc.useFileAttachmentAsTemplate,
      usageTypes: dwc.usageTypes,
    };
  }
}
